import React from 'react';
import { useTranslation } from 'react-i18next';

import { Banner } from 'fe-shared/src/components';

import { Transaction } from '../../../types';

import styles from './ProcessingStatusBanner.module.scss';

interface Props {
  transaction: Transaction;
}

const RECEIPT_CREATION_OPERATION_CODE = 'ReceiptCreation';

const ProcessingStatusBanner = ({ transaction }: Props) => {
  const { t } = useTranslation();
  const {
    processingOperationCode,
    processingStatusCode,
    processingFailureReason,
  } = transaction;

  if (processingOperationCode !== RECEIPT_CREATION_OPERATION_CODE) {
    return null;
  }

  if (processingStatusCode === 'InProgress') {
    return (
      <Banner
        id="processing-status-in-progress-banner"
        variant="info"
        title={t('createReceiptDialog.banner.processingInProgress')}
        className={styles.processingStatusBannerWrapper}
      />
    );
  }

  if (processingStatusCode === 'Failed') {
    return (
      <Banner
        id="processing-status-failed-banner"
        variant="error"
        title={t('createReceiptDialog.banner.processingFailed', {
          reason: processingFailureReason || t('createReceiptDialog.banner.processingFailedUnknownReason'),
        })}
        className={styles.processingStatusBannerWrapper}
      />
    );
  }

  return null;
};

export default ProcessingStatusBanner;
